// extracted by mini-css-extract-plugin
export default {"label":"tabs_label__m+DtD","activeLabel":"tabs_activeLabel__fBfOb","tabs":"tabs_tabs__-KEOh","selectTab":"tabs_selectTab__U+-UI"};